import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IconSettings } from '@components/Icons/Icons';

export const navId = 'subNavContentUserSettings';
const links = () => [
  { title: 'General', href: '/settings/general' },
  { title: 'Contact details', href: '/settings/contact' },
  { title: 'Logout', href: '/logout' },
];
const userSettingsSubNav = () => {
  const { login, is_hijacked: isHijacked } =
    useSelector((state) => state.auth.user) || '';
  const navigate = useNavigate();

  const linksArray = links();
  return {
    navId,
    title: isHijacked ? `[DEV] ${login}` : login,
    href: '/settings',
    icon: IconSettings,
    links: linksArray,
    onClick: (e) => {
      e.preventDefault();
      navigate(linksArray[0].href);
    },
  };
};
export default userSettingsSubNav;
